module.exports = __webpack_public_path__ + "img/cooperation3.9359426b.png";